module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"from":"From","to":"To"},"de":{"from":"Von","to":"Bis"},"fr":{"from":"De","to":"À"},"it":{"from":"Da","to":"A"}}')
  delete Component.options._Ctor
}
